<template>
  <v-card>
    <v-card-title class="headline">Send notification</v-card-title>
    <v-card-text>
      <div class="grey-area">
        <p :class="{'error--text': !!errors.includes('Send to')}"><strong>Send to</strong></p>
        <v-radio-group v-model="sendToOption" row>
          <v-radio label="All users" value="All users"></v-radio>
          <v-radio label="User" value="User"></v-radio>
          <v-radio label="Group" value="Group"></v-radio>
        </v-radio-group>
        <div v-if="sendToOption === 'User'">
          <UserSelector :label="'Username'" @userSelected="sendToUserSelected"/>
        </div>
        <div v-if="sendToOption === 'Group'">
          <p>Choose one or more groups : </p>
          <v-checkbox v-model="clubFollowersTopicActive" :label="'Club followers'"></v-checkbox>
          <div v-if="clubFollowersTopicActive">
            <SportSelector v-model="clubSelectorSportID" :label="'Sport name'"/>
            <ClubSelector v-if="clubSelectorSportID" :label="'Club name'" :sportID="clubSelectorSportID" @clubSelected="clubSelected"/>
          </div>
          <v-checkbox v-model="userFollowersTopicActive" :label="'Author followers'"></v-checkbox>
          <div v-if="userFollowersTopicActive">
            <UserSelector :label="'Username'" @userSelected="userSelected"/>
          </div>
          <v-checkbox v-model="sportFollowersTopicActive" :label="'Sport followers'"></v-checkbox>
          <div v-if="sportFollowersTopicActive">
            <SportSelector v-model="sportFollowersSendTo" :label="'Sport name'"/>
          </div>
        </div>
      </div>
      <TranslatableInput v-model="title" label="Title (required)" placeholder="Title" required :error="errors.includes('Title')"></TranslatableInput>
      <TranslatableInput v-model="content" label="Text" placeholder="Text"></TranslatableInput>
      <div class="two-columns">
        <v-text-field v-model="videoID" label="Video" placeholder="ID"></v-text-field>
        <div class="small-column" v-if="video">
          <p>{{ video.club1Alias }} - {{ video.club2Alias }}</p>
        </div>
      </div>
      <div class="two-columns">
        <v-text-field v-model="imageURL" label="Image" placeholder="URL" :loading="imageURLLoading"></v-text-field>
        <div class="small-column" v-if="imageURL">
          <img class="video-thumbnail" :src="imageURL"/>
        </div>
      </div>
      <v-checkbox v-model="customizePublishDate" :label="'Schedule publication'"></v-checkbox>
      <div class="two-columns" v-if="customizePublishDate">
        <DateSelector @dateSelected="scheduleDateChosen"/>
      </div>
      <div class="two-columns" style="margin-top: 30px;">
        <v-text-field v-model="deeplinkOptions" label="Deeplink" placeholder="Deeplink" :loading="deeplinkOptionsLoading" :disabled="!customizeDeeplink"></v-text-field>
        <div class="center-aligned">
          <v-checkbox v-model="deeplinkMyAccount" :label="'Opened in user account tab'"></v-checkbox>
        </div>
      </div>
      <v-checkbox v-model="customizeDeeplink" :label="'Customize deeplink'"></v-checkbox>
      <div v-if="customizeDeeplink">
        <p id="deeplink-list-title">Deeplinks list</p>
        <p id="deeplink-list">
          {"trend":"true"}  // ouvre l'onglet à la une<br/><br/>
          {"tv":"true"} // ouvre l'onglet tv<br/><br/>
          {"account":"true"} // ouvre l'onglet mon compte<br/><br/>
          {"videoID":"br72mtnf9aac72hm9u7g"} // ouvre le player (mode vidéo) sur la vidéo<br/><br/>
          {"videoID":"br72mtnf9aac72hm9u7g", "account":"true"} // ouvre le player (mode vidéo) sur la vidéo, avec l'onglet mon compte ouvert derrière<br/><br/>
          {"videoID":"br72mtnf9aac72hm9u7g", "commentID":"brb0tu3tmilc72jlasdg"}  // ouvre l'écran commentaire, avec le player derrière<br/><br/>
          {"videoID":"br72mtnf9aac72hm9u7g", "account":"true", "commentID":"brb0tu3tmilc72jlasdg"}  //<br/><br/>
          {"matchID":"br3rp5tv15ss72m51hn0"} // ouvre le player (mode match), sur le premier résumé<br/><br/>
          {"matchID":"br3rp5tv15ss72m51hn0", "videoID":"br3rpv62qcgs72p2b2lg"} // ouvre le player (mode match), sur cette video<br/><br/>
          {"matchID":"br3rp5tv15ss72m51hn0", "videoID":"br3rpv62qcgs72p2b2lg", "account":"true"} // ouvre le player (mode match), sur cette video, avec l'onglet mon compte ouvert derrière
        </p>
      </div>
      <v-alert
        :value="errors.length !== 0"
        type="error"
      >
        <p class="mb-1 body-2">
          Error on the following fields:
        </p>
        <ul>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat="flat" @click.native="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" flat="flat" v-show="!sendingNotif" @click.native="sendNotification">Send</v-btn>
      <v-btn color="primary" flat="flat" v-show="sendingNotif" @click.native="''">Sending...</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>

import SportSelector from '@/components/SportSelector'
import ClubSelector from '@/components/common/ClubSelector'
import UserSelector from '@/components/common/UserSelector'
import DateSelector from '@/components/common/DateSelector'
import TranslatableInput from '@/components/forms/TranslatableInput'
import XXH from 'xxhashjs'
import env from '@/tools/env'

export default {
  name: 'NotifCreator',
  components: {
    SportSelector,
    ClubSelector,
    UserSelector,
    DateSelector,
    TranslatableInput
  },
  data () {
    return {
      env,
      sendingNotif: false,

      errors: [],

      sendToOption: '',

      clubFollowersTopicActive: false,
      clubSelectorSportID: null,
      userFollowersTopicActive: false,
      sportFollowersTopicActive: false,

      userSendTo: null,
      clubFollowersSendTo: '',
      userFollowersSendTo: '',
      sportFollowersSendTo: '',

      notifSportID: null,

      title: {
        en: '',
        fr: ''
      },
      content: {
        en: '',
        fr: ''
      },

      videoID: '',
      video: null,

      imageURLLoading: false,
      customImageLoaded: false,
      imageURL: '',

      customizePublishDate: false,
      customPublishDate: null,

      deeplinkOptionsLoading: false,
      deeplinkMyAccount: false,
      deeplinkOptions: null,
      customizeDeeplink: false,

      createdItem: {
        label: '',
        title: '',
        content: '',
        imageUrl: '',
        disabled: false,
        description: null,
        params: [],
        topics: [],
        is_auto: false,
        sportIDs: []
      },

      sendItem: {
        user_id: '',
        topics: [],
        notification_variables: {},
        notification_data: {}
      },

      globalTopics: {
        FR: {
          prod: 'rematch',
          preprod: 'rematchPreprod',
          dev: 'rematchPreprod'
        },
        US: {
          prod: 'rematchUS',
          preprod: 'rematchPreprodUS',
          dev: 'rematchPreprodUS'
        }
      }
    }
  },
  methods: {
    scheduleDateChosen (date) {
      this.customPublishDate = date
    },
    sendNotification () {
      this.errors = []
      if (!this.userSendTo === null && !this.clubFollowersSendTo && !this.userFollowersSendTo && !this.sportFollowersSendTo && (this.sendToOption !== 'All users')) {
        this.errors.push('Send to')
      }
      if (!this.title.en || !this.title.fr) {
        this.errors.push('Title')
      }
      if (this.customizePublishDate && !this.customPublishDate) {
        this.errors.push('Custom publish date')
      }
      if (this.customPublishDate === 'error') {
        this.errors.push('Custom publish date')
      }
      if (this.errors.length !== 0) {
        return
      }

      this.sendingNotif = true

      // label
      let timestamp = Date.now()
      let labelizedtitle = this.title.en.slice(0, 16).trim()
      labelizedtitle = labelizedtitle.replace(/[^a-zA-Z ]/g, '')
      labelizedtitle = labelizedtitle.replace(/ /g, '-')
      this.createdItem.label = `${labelizedtitle}-${timestamp}`

      // title
      this.createdItem.title = this.title

      // content
      this.createdItem.content = this.content

      // imageURL
      if (this.imageURL) {
        this.createdItem.imageUrl = this.imageURL
      } else {
        delete this.createdItem.imageURL
      }

      // sportIDs
      if (this.notifSportID) {
        this.createdItem.sportIDs = [this.notifSportID]
      }

      // topics / user_id
      if (this.sendToOption === 'All users') {
        delete this.sendItem.user_id
        this.createdItem.topics.push(this.globalTopics[this.$country][env])
        this.sendItem.topics.push(this.globalTopics[this.$country][env])
      } else if (this.sendToOption === 'User') {
        delete this.sendItem.topics
        this.sendItem.user_id = this.userSendTo.id
        this.createdItem.userID = this.userSendTo.id
        this.createdItem.label = this.userSendTo.preferredUsername + '-' + this.createdItem.label
      } else if (this.sendToOption === 'Group') {
        delete this.sendItem.user_id
        if (this.clubFollowersSendTo) {
          this.createdItem.topics.push(this.clubFollowersSendTo)
          this.sendItem.topics.push(this.clubFollowersSendTo)
        }
        if (this.userFollowersSendTo) {
          this.createdItem.topics.push(this.userFollowersSendTo)
          this.sendItem.topics.push(this.userFollowersSendTo)
        }
        if (this.sportFollowersSendTo) {
          this.createdItem.topics.push(this.sportFollowersSendTo)
          this.sendItem.topics.push(this.sportFollowersSendTo)
        }
      }

      // custom publish date
      if (this.customPublishDate) {
        this.createdItem.notifyAt = this.customPublishDate
      }

      // deeplink
      if (this.deeplinkOptions) {
        this.sendItem.notification_data = JSON.parse(this.deeplinkOptions)
      }
      this.$store.dispatch('createNotification', this.createdItem)
        .then(() => {
          if (this.customPublishDate) {
            this.sendingNotif = false
            this.resetData()
            this.$emit('close')
          } else {
            this.$store.dispatch('sendNotification', {
              label: this.createdItem.label,
              params: this.sendItem
            }).then(() => {
              this.sendingNotif = false
              this.resetData()
              this.$emit('close')
            }).catch(err => {
              this.sendingNotif = false
              console.log(err)
              alert('Error sending notification')
            })
          }
        })
        .catch(err => {
          console.log(err)
          alert('Error creating notification')
        })
    },
    sendToUserSelected (user) {
      this.userSendTo = user
    },
    clubSelected (clubid) {
      this.clubFollowersSendTo = clubid
      if (!this.notifSportID) {
        this.notifSportID = this.clubSelectorSportID
      }
    },
    userSelected (userid) {
      let h = XXH.h64(userid, null).toString(10)
      this.userFollowersSendTo = h
    },
    resetData () {
      this.errors = []
      this.sendToOption = ''
      this.clubFollowersTopicActive = false
      this.clubSelectorSportID = null
      this.userFollowersTopicActive = false
      this.sportFollowersTopicActive = false
      this.userSendTo = null
      this.clubFollowersSendTo = ''
      this.userFollowersSendTo = ''
      this.sportFollowersSendTo = ''
      this.notifSportID = null
      this.title = ''
      this.content = ''
      this.videoID = ''
      this.video = null
      this.imageURLLoading = false
      this.customImageLoaded = false
      this.imageURL = ''
      this.customizePublishDate = false
      this.customPublishDate = null
      this.deeplinkOptionsLoading = false
      this.deeplinkMyAccount = false
      this.deeplinkOptions = null
      this.customizeDeeplink = false
      this.createdItem = {
        label: '',
        title: '',
        content: '',
        imageUrl: '',
        disabled: false,
        description: null,
        params: [],
        topics: [],
        is_auto: false,
        sportIDs: []
      }
      this.sendItem = {
        user_id: '',
        topics: [],
        notification_variables: {},
        notification_data: {}
      }
    }
  },
  watch: {
    'videoID' () {
      if (this.videoID.length === 20) {
        this.imageURLLoading = true
        this.deeplinkOptionsLoading = true
        this.$store.dispatch('getVideo', this.videoID)
          .then(vid => {
            this.video = vid
            if (!this.notifSportID) {
              this.notifSportID = vid.sportID
            }
            this.imageURL = vid.thumbnailURL
            this.deeplinkOptions = JSON.stringify({ videoID: vid.id })
            this.imageURLLoading = false
            this.deeplinkOptionsLoading = false
          })
          .catch(err => {
            this.video = null
            this.imageURL = null
            this.imageURLLoading = false
            this.deeplinkOptionsLoading = false
            console.log(err)
            alert('error trying to get video')
            this.videoID = ''
          })
      } else {
        this.video = null
        this.imageURL = null
        this.deeplinkOptions = null
      }
    },
    'imageURL' () {
      if (this.imageURL) {
        let extension = this.imageURL.slice(this.imageURL.length - 4, this.imageURL.length)
        if (extension === '.jpg' || extension === '.png') {
          this.customImageLoaded = true
        } else {
          this.customImageLoaded = false
        }
      } else {
        this.customImageLoaded = false
      }
    },
    'deeplinkMyAccount' () {
      if (!this.deeplinkOptions) {
        setTimeout(() => {
          this.deeplinkMyAccount = false
        }, 300)
      } else {
        if (this.deeplinkMyAccount === true) {
          let dpoptions = JSON.parse(this.deeplinkOptions)
          this.deeplinkOptions = JSON.stringify({
            ...dpoptions,
            account: 'true'
          })
        } else {
          let opts = JSON.parse(this.deeplinkOptions)
          delete opts.account
          this.deeplinkOptions = JSON.stringify({
            ...opts
          })
        }
      }
    },
    'sportFollowersSendTo' () {
      if (!this.notifSportID) {
        this.notifSportID = this.sportFollowersSendTo
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .grey-area {
    margin-bottom: 42px;
    padding: 12px;
    background-color: #f1f3fc;
  }

  .two-columns {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 24px;
  }

  .small-column {
    width: 202px;
    align-self: center;
  }

  .video-thumbnail {
    width: 100%;
  }

  #deeplink-list-title {
    font-weight: bold;
    color: #5a5a5a;
  }

  #deeplink-list {
    padding: 18px;
    background-color: #fafafa;
    font-size: 12px;
    color: #5a5a5a;
  }

  .error--text {
    margin-left: 18px;
  }

</style>



// WEBPACK FOOTER //
// src/components/NotifCreator.vue